module.exports = __webpack_public_path__ + "static/media/poland.6e10627c.svg";